module.exports = __webpack_public_path__ + "img/SkillsCompact.22b7570b.svg";